import React from "react";
import FeatherIcon from "components/FeatherIcon";

type AddUpsellItemProps = {
    optionId: number;
    available: number; // pôv. props.count
    usedCount: number; // pôv. props.used_count
    onAdd: (optionId: number) => void;
    onRemove: (optionId: number) => void;
};

const AddUpsellItemBase: React.FC<AddUpsellItemProps> = ({optionId, available, usedCount, onAdd, onRemove}) => {
    if (usedCount === 0) {
        return (
            <button
                type="button"
                className="AddUpsellItemPlus box-content px-[17px] md:px-[16px] flex items-center justify-center transform-gpu duration-150 focus:active:hover:text-arbo-green rounded-full"
                onClick={() => onAdd(optionId)}
            >
                <FeatherIcon name="plus-circle" className={"size-[20px] md:size-[30px] flex-none"} strokeWidth={2} />
            </button>
        );
    }

    if (usedCount > 0) {
        return (
            <div className="AddUpsellActionsPill rounded-full bg-arbo-lightGreen transform-gpu duration-150 text-black text-xs font-medium p-2 md:p-3 grid grid-cols-3 items-center justify-center animate-to-left mx-[17px] md:mx-[16px]">
                <button
                    className="flex items-center justify-center focus:active:hover:bg-black/10 rounded-full"
                    type="button"
                    onClick={() => onRemove(optionId)}
                >
                    {usedCount > 1 ? (
                        <FeatherIcon className="size-[20px] md:size-[30px] flex-none" name="minus" strokeWidth={2} />
                    ) : (
                        <FeatherIcon className="size-[20px] md:size-[30px] flex-none" name="trash" strokeWidth={2} />
                    )}
                </button>

                <span className="text-xs md:text-base text-center font-semibold">{usedCount}</span>

                <button
                    className="flex items-center justify-center focus:active:hover:bg-black/10 rounded-full"
                    type="button"
                    onClick={() => available >= 1 && onAdd(optionId)}
                >
                    {available >= 1 && <FeatherIcon name="plus" className="size-[20px] md:size-[30px] flex-none" strokeWidth={2} />}
                </button>
            </div>
        );
    }

    return null;
};

const areEqual = (prev: AddUpsellItemProps, next: AddUpsellItemProps) =>
    prev.optionId === next.optionId &&
    prev.available === next.available &&
    prev.usedCount === next.usedCount &&
    prev.onAdd === next.onAdd &&
    prev.onRemove === next.onRemove;

export const AddUpsellItem = React.memo(AddUpsellItemBase, areEqual);
